module.exports = __webpack_public_path__ + "img/Logo-header.575f7165.svg";